<script>
  export let years;
  export let selectedYear;
  export let selectedIndicator;
  export let colorBy;

  const setYear = (e) => {
    selectedYear = parseInt(e);
  };

  const setIndicator = (e) => {
    selectedIndicator = e;
    colorBy = e;
  };
</script>

<div class="interactive__options">
  <div class="interactive__options--dropdown">
    <span class="interactive__options--label">Select Year:</span>
    <select class="input__select" on:change={(e) => setYear(e.target.value)}>
      {#each years as year}
        <option value={year}>{year}</option>
      {/each}
    </select>
  </div>

  <div class="interactive__options--indicators">
    <span class="interactive__options--label interactive__options--group">Group By: </span>
    <button
      class:btn--active={selectedIndicator === "region"}
      class="btn btn--select btn-region"
      on:click={(e) => setIndicator("region")}>Region</button
    >
    <button
      class:btn--active={selectedIndicator === "income_level"}
      class="btn btn--select btn-income"
      on:click={(e) => setIndicator("income_level")}>Income Level</button
    >
  </div>
</div>

<style type="text/scss">
  @import "../scss/components/_buttons.scss";
  @import "../scss/components/_form-elements.scss";
  @import "../scss/custom/_options.scss";
</style>
